import { RequestService } from '~/services/RequestService'

export class SchoolDirectionsService {
  constructor(private requestService: RequestService) {}

  // readonly urls = {
  //   schoolDirections: '/api/school/directions'
  // };

  public getSchoolDirectionsList<T>(): Promise<T> {
    // return await this.requestService.request({
    //   url: `${this.urls.schoolDirections}`,
    // });
    return new Promise<T>(<T>(resolve) => {
      <T>resolve([
        {
          id: 'event3',
          name: 'Участвуй и выигрывай в олимпиадах',
          background: 'linear-gradient(180deg, #CFFDD9 0%, #E1FFDE 100%)',
          image: 'calendar.png',
          href: '/olympiad'
        },
        {
          id: 'event5',
          name: 'Узнай свои карьерные траектории',
          background: 'linear-gradient(130.5deg, #CFCFFD -28.36%, #DEE3FF 113.83%)',
          image: 'globus.png',
          href: '/career-navigator'
        },
        {
          id: 'event6',
          name: 'Учись на платформе Агроклассы',
          background: '#F2FA93',
          image: 'lamp.png',
          href: 'https://agroclasses.svoevagro.ru/?utm_source=svoevagro'
        },
        {
          id: 'event7',
          name: 'Узнай, куда ты можешь поступить, через калькулятор ЕГЭ',
          background: 'rgba(135,227,220,0.92)',
          image: 'book.png',
          href: '/calculator-ege'
        },
        {
          id: 'event8',
          name: 'Выбери специальность в вузах России',
          background: '#F2FA93',
          image: 'backpack.png',
          href: '/universities'
        },
        {
          id: 'event9',
          name: 'Выбери специальность в ссузах России',
          background: 'linear-gradient(130.5deg, #FDE2CF -28.36%, #FFFEDE 113.83%)',
          image: 'column.png',
          href: '/colleges'
        },
        {
          id: 'event10',
          name: 'Найди свое призвание с помощью “Агровектора”',
          background: '#93fab0',
          image: 'flask.png',
          href: '/news/agrovektor-ot-ucheby-k-uspekhu-uznayte-vse-o-rabote-v-apk-i-napryamuyu-poobshchaytes-s-predstavitelyami-biznesa-i-nauki'
        },
        {
          id: 'event11',
          name: 'Выбери лучшего работодателя',
          background: '#FFCDA9',
          image: 'statuette.png',
          href: '/news/rabotayte-u-luchshikh-s-ya-v-agro-onlayn-ekskursii-oplachivaemye-stazhirovki-i-vakansii-ot-kompaniy-apk'
        }
      ])
    })
  }
}
